import Layout from "components/layout";
// import Auth from "pages/auth";
// import Login from "pages/auth/Login";
// import Register from "pages/auth/Register";
// import ForgetPassword from "pages/auth/ForgetPassword";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard } from "utilities/AuthGuard";
import "./App.css";
import UsersContainer from "pages/users/UsersContainer";
import DigitalTwinContainer from "pages/DigitalTwinList/digitaltwinContainer";
import OrganizationAndUsersContainer from "pages/organization-and-users/OrganizationAndUsers";
import Logs from "pages/logs/Logs";
import Roles from "pages/roles/page";

import ActivityDetails from 'components/logs/ActivityDetails';
import ReportedActivity from 'components/logs/ReportedActivity';
import Tickets from "pages/tickets/Tickets";
import NewDashboard from "components/NewDashboard";
import Projects from "pages/Projects/projects";
import Plans from "pages/plans/page";
import Subscribers from "pages/subscribers/Subscribers";
import Users from "pages/users/Users";
import Invoices from "pages/invoices/Invoices";
import Guides from "pages/guides/Guides";
import { AdminGuard } from "utilities/AdminGuard";
import Settings from "pages/settings/Settings";


// import UnityWP from "pages/waterplant";

function App() {
  return (
    <Routes>
      {/* <Route path="/auth">
        <Route element={<Auth />}>
          <Route index element={<Navigate to="/auth/login" />} />
          <Route path="login" element={<Login />}></Route>
          <Route path="register" element={<Register />}></Route>
          <Route path="forget-password" element={<ForgetPassword />}></Route>
        </Route>
      </Route> */}
      <Route element={<AuthGuard />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/projects" />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/dashboard" element={<NewDashboard />} />
          
          {/* Admin protected routes */}
          <Route element={<AdminGuard />}>
            <Route path="/guides" element={<Guides />} />
          </Route>

          <Route path="/users" element={<Users />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/digital-twins" element={<DigitalTwinContainer />} />
          <Route path="/organization-and-users" element={<OrganizationAndUsersContainer type="superadmin" />} />
          <Route path="/users-and-projects" element={<OrganizationAndUsersContainer type="user" />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/logs/activity/:id" element={<ActivityDetails />} />
          <Route path="/logs/activity/reported" element={<ReportedActivity />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/subscribers" element={<Subscribers />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
        {/* <Route path="/3d-dashboard" element={<UnityContainer />} /> */}
      </Route>
      <Route path="*" element={<p>Not Found</p>} />
    </Routes>
  );
}

export default App;
